module.exports = __webpack_public_path__ + "265d5197ff89e5297c0044023ed4d239.svg";